import React, { useMemo } from 'react';
import LanguageBarItem from 'components/LanguageBarItem/LanguageBarItem';
import { TLanguageIDs, ITags } from 'types';
import { trueOrderLanguageIDs } from 'appConstants';
import style from './LanguageBar.module.scss';

interface ILanguageBar {
	setSelectedLanguage(value: Nullable<string>): void;
	selectedLanguage: Nullable<string>;
	tags: ITags[];
	IDCustomerDefaultLanguage: string;
}

const LanguageBar: React.FC<ILanguageBar> = ({
	setSelectedLanguage,
	selectedLanguage,
	tags,
	IDCustomerDefaultLanguage,
}) => {
	const LanguageIDsWithEmptyTags = useMemo(
		() => tags.filter((el) => el.tags.includes('')).map((el) => el.languageId),
		[tags],
	);

	const languageIds = useMemo(() => tags.map((el) => el.languageId), [tags]);

	const sortedLanguages = useMemo(() => {
		const languages = tags.map((tag) => tag.languageId);
		const sortByObject: { [key: string]: number } = trueOrderLanguageIDs.reduce((obj, item, index) => {
			return {
				...obj,
				[item]: index,
			};
		}, {});
		languages.sort((a, b) => sortByObject[a] - sortByObject[b]);
		languages.sort((a) => (a === IDCustomerDefaultLanguage ? -1 : 1));
		return languages;
	}, [tags, IDCustomerDefaultLanguage]);

	return (
		<>
			{languageIds.length ? (
				<div className={style.container} data-test="LanguageBar">
					{sortedLanguages.map((el) => {
						const itemHasError = LanguageIDsWithEmptyTags.includes(el as TLanguageIDs);

						return (
							<LanguageBarItem
								key={el}
								onClick={() => setSelectedLanguage(el)}
								languageId={el as TLanguageIDs}
								isActive={selectedLanguage === el}
								isDefault={IDCustomerDefaultLanguage === el}
								itemHasError={itemHasError}
							/>
						);
					})}
				</div>
			) : null}
		</>
	);
};

export default React.memo(LanguageBar);
